/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * テナントロール（admin: 管理者, editor: 編集者）
 */
export type TenantUserRoleSchema = (typeof TenantUserRoleSchema)[keyof typeof TenantUserRoleSchema];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantUserRoleSchema = {
  admin: 'admin',
  editor: 'editor',
} as const;
